/** トライアル期間（日数） */
export const TRIAL_DAYS = 14;
